import { Component, Inject } from '@angular/core';
import { GriddingStatusService } from '../tenant-view/tenant-view-services/gridding-status.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import dayjs, { Dayjs } from 'dayjs';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import { ExportGriddingService } from './gridding-services/export-gridding.service';

/**
 * @deprecated Use MapsGriddingComponent (src/app/maps/maps-gridding/) instead.
 * This component will be removed once the new maps module fully replaces tenant-view.
 */
@Component({
  selector: 'app-gridding',
  standalone: false,
  templateUrl: './gridding.component.html',
  styleUrl: './gridding.component.css',
})
export class GriddingComponent {

isGriddingOptionslVisible: boolean = false;
panelOpenState: boolean = false;

selectedAnalysisType: string = '';

currentYear = dayjs().format('YYYY');
tenYearPeriod = [];
griddingData = [];
groupedGriddingData = [];

 public tenantId: number;

constructor(
  private griddingStatusService: GriddingStatusService,
  public dialogRef: MatDialogRef<GriddingComponent>,
  public nav: NavBarComponent,
  private exportGriddingService: ExportGriddingService,
  @Inject(MAT_DIALOG_DATA) public data: any
){
  this.tenantId = this.data?.tenantId;
}

ngOnInit(){
  this.nav.toggleLoading(true);
  this.setTenYearPeriod();
  this.selectedAnalysisType = 'ALL';
  this.populateGriddingDateData('ALL');
}

    clickType(type: string){
      this.nav.toggleLoading(true);
      // console.log('Full type value being sent:', type);
      this.selectedAnalysisType = type;
      this.populateGriddingDateData(type);
  }

    onCloseClick() {
    this.dialogRef.close();
  }

  setTenYearPeriod(){
      for(let i = 0; i < 10; i++){
        this.tenYearPeriod.push(dayjs().subtract(i, 'year').format('YYYY'));
      }  
      this.tenYearPeriod.reverse();  
      // console.log(this.tenYearPeriod.reverse(), 'last ten years');
  }
  
  groupDataByFarm(data: any[]) {
    const farmMap = new Map();
    
    data.forEach(item => {
      if (!farmMap.has(item.farm_id)) {
        farmMap.set(item.farm_id, {
          farm_id: item.farm_id,
          farmName: item.farm_name,
          fields: new Map()
        });
      }
      
      const farm = farmMap.get(item.farm_id);
      
      if (!farm.fields.has(item.field_id)) {
        farm.fields.set(item.field_id, {
          field_id: item.field_id,
          field_name: item.field_name,
          field_size: item.field_size,
          status: item.status,
          analyses: []
        });
      }
      
      // Add this analysis to the field's analyses array
      farm.fields.get(item.field_id).analyses.push({
        type: item.type,
        date_performed: item.date_performed,
        status: item.status
      });
    });
    
    // Convert Maps to Arrays for template usage
    this.groupedGriddingData = Array.from(farmMap.values()).map(farm => ({
      ...farm,
      fields: Array.from(farm.fields.values())
    }));
    
    // console.log(this.groupedGriddingData, 'Grouped Data');
  }
  
  matchDateToYear(field: any, year: string): string {
    const analysesInYear = field.analyses.filter(analysis => 
      dayjs(analysis.date_performed).format('YYYY') === year
    );
    
    if (analysesInYear.length === 0) return '-';
    
    const types = analysesInYear.map(analysis => analysis.type);
    const hasTopSoil = types.includes('CHEMICAL - TOP SOIL');
    const hasSubSoil = types.includes('CHEMICAL - SUB SOIL');
    
    if (hasTopSoil && hasSubSoil) return 'CT/CS';
    if (hasTopSoil) return 'CT';
    if (hasSubSoil) return 'CS';
    
    return '-';
  }
  
  getStatusClass(status: number | string): string {
    if (status === 0) return 'row-up-to-date';
    if (status === '10+' || Number(status) > 3) return 'row-out-of-date';
    return 'row-needs-action';
  }

  calculateGriddingHectaresPerYear(farm: any, year: string): string {
    return farm.fields
      .filter(field => field.analyses.some(a => dayjs(a.date_performed).format('YYYY') === year))
      .reduce((sum, field) => sum + (field.field_size || 0), 0)
      .toFixed(2);
  }
  
    populateGriddingDateData(analysisType: string) {
      let dataTenantID = this.data.tenantId;
      // console.log(dataTenantID, 'tenantId');
        this.selectedAnalysisType = Array.isArray(analysisType) ? analysisType.join(', ') : analysisType;
        this.griddingStatusService.getGriddingTimelineData(this.tenantId, analysisType).subscribe({
          next: (result) => {

            console.log(result[0]?.field_size, 'result grid data');
            if (result) {
              this.griddingData = result.filter(item => item.field_id === dataTenantID);
              this.groupDataByFarm(result);
            }
            this.nav.toggleLoading(false);
          },
          error: () => {
            this.nav.toggleLoading(false);
          }
        });
    }

exportGriddingAsExcel() {
  const tenantId = this.tenantId;// your tenant ID source
  const analysisType = this.selectedAnalysisType === 'ALL' ? null : [this.selectedAnalysisType];// optional: ['CHEMICAL - TOP SOIL'] or ['CHEMICAL - SUB SOIL'] or null for all
  
  if (tenantId) {
    this.exportGriddingService.postExportGriddingAsExcel(tenantId, analysisType).subscribe(blob => {
      blob.text().then(base64String => {
        const binaryString = atob(base64String);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        
        const excelBlob = new Blob([bytes], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
        const filename = `analysis_gridding_export_${timestamp}.xlsx`;
        
        const url = window.URL.createObjectURL(excelBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
      this.nav.toggleLoading(false);
    });
  }
}

}
